/*global chrome*/
import React from "react";
import logo from "../../assets/icons/logo.png";

import axios from 'axios';
import { toastify } from '../../components/Toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import useAnonymousIntercom from "../intercom/useAnonymousIntercom";

function Login() {
    useAnonymousIntercom();
    const navigate = useNavigate();
    const [resendEmail, setResendEmail] = React.useState(false);

    const sendTokenToChromeExtension = ({ extensionId, jwt }) => {
        try {
            if (chrome && chrome?.runtime) {
                chrome.runtime.sendMessage(extensionId, { jwt }, response => {
                    // if (!response.success) {
                    //   return response;
                    // }

                });
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleSubmit = async (e) => {
        // /setLoading(true);
        e.preventDefault();

        const data = {
            email: e.target.email.value,
            password: e.target.password.value
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API}users/login`, data);
             // Debugging: Log the response

            toastify("success", "Successfully Login");
            localStorage.setItem('token', response.data.data.token);
            localStorage.setItem('userData', JSON.stringify(response.data.data.user));
            sendTokenToChromeExtension({ extensionId: process.env.REACT_APP_EXTENSION_ID, jwt: response.data.data.token });

            setTimeout(() => {
                navigate(`/app/buckets`);
            }, 1000);
        } catch (err) {
            if (err.response) {
                console.error(err.response.data.message);
                (err.response.data.message === 'Please verify your email first') ? setResendEmail(true) : setResendEmail(false);
                toastify("error", err.response.data.message);
            } else {
                console.error(err.message); // Log any other errors that don't have a response object
                toastify("error", "An error occurred");
            }
        };
    };

    return (
        <div className="loginHolder min-h-[100vh] flex items-center bg-[#F3F4F6]">
            <div className="formHolder bg-white w-full px-4 sm:px-8 md:w-1/2 lg:w-2/5 max-w-lg sm:mx-auto my-5 py-8 sm:rounded-lg sm:shadow sm:border-auth">
                <div className="logo">
                    <img alt="Zimzee" src={logo} className="logo-centered" />
                </div>
                <h3 className="text-xl mt-7 mb-6 font-bold text-[24px] text-center">Sign in to Zimzee</h3>
                <form onSubmit={handleSubmit} className="loginForm flex flex-col">
                    {/* style={{borderColor:"#D9D9D9 !important", borderWidth: '1px'}} */}
                    <input className="border-2 border-[#D9D9D9] bg-white my-3 p-3 rounded-md" type="email" id="email" placeholder="Your Email" />
                    <input className="bg-white border-2 border-[#D9D9D9] my-3 p-3 rounded-md" type="password" id="password" placeholder="Password" />
                    {(resendEmail) ? (
                        <a className="underline pl-2 my-1 text-[#000]" href="/resendEmail">Resend Email</a>
                    ) : ("")}
                    <button type="submit" className="button bg-[#FF6600] text-white py-2 rounded-[5px] mt-4">Login</button>
                    <div className="remember flex justify-between my-4">
                        <label className="text-[#394150] font-bold rememberMe">
                            <input className="mr-2" type="checkbox" />
                            Remember me
                        </label>
                        <a className="text-[#394150] text-blue-600 font-semibold hover:underline" href="/forgotPassword">Set a new password</a>
                        <a className="text-[#394150] text-blue-600 font-semibold hover:underline" href="/">Sign in with email</a>
                    </div>
                </form>
                {/* <div className="mt-4 text-center">
                    <hr className="-mb-3 border-[#394150]" />
                    <span className="inline-block bg-white text-center text-[#394150] px-3">OR</span>
                </div> */}
                {/* <a href="/loginmagic" type="button" className="flex justify-center py-3 mt-7" style={{border:"1px solid #D9D9D9", borderRadius: "50px",width:"100%"}}>
                    <img className="pr-3" src={magicLinkIcon} />
                    <span className="font-bold">Login with a password-free Magic Link</span>
                </a> */}
                <h4 className="text-gray-500 text-center" style={{ marginTop: "45px" }}>First time here? <a className="text-[#5587e9] text-blue-600 font-semibold hover:underline" href="https://zimzee.com">Create account</a></h4>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Login;
